import {
    Attach24Regular,
    Bookmark24Regular,
    ChevronDown24Regular,
    Mic24Regular,
    Send24Filled
} from "@fluentui/react-icons";
import {FC, KeyboardEvent} from "react";
import {BrandSparkleIcon} from "./icons";

interface IntelligencePromptBarProps {
    value: string;
    disabled: boolean;
    onChange: (value: string) => void;
    onSend: () => void;
    onSave: () => void;
    /** "inline" renders in normal flow (top of the empty state) instead of pinned to the bottom. */
    variant?: "sticky" | "inline";
}

const IntelligencePromptBar: FC<IntelligencePromptBarProps> = ({
    value,
    disabled,
    onChange,
    onSend,
    onSave,
    variant = "sticky"
}) => {
    const canSend = value.trim().length > 0 && !disabled;
    const canSave = value.trim().length > 0;

    const handleKeyDown = (event: KeyboardEvent<HTMLTextAreaElement>): void => {
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            if (canSend) {
                onSend();
            }
        }
    };

    return (
        <div
            className={`pi-promptbar${
                variant === "inline" ? " pi-promptbar--inline" : ""
            }`}
        >
            <div className="pi-promptbar__field">
                <textarea
                    className="pi-promptbar__textarea"
                    rows={4}
                    placeholder="Ask PAR Intelligence anything about your business…"
                    value={value}
                    disabled={disabled}
                    onChange={(event) => onChange(event.target.value)}
                    onKeyDown={handleKeyDown}
                />
                <div className="pi-promptbar__row">
                    <button type="button" className="pi-promptbar__model">
                        <BrandSparkleIcon />
                        PAR Intelligence
                        <ChevronDown24Regular />
                    </button>
                    <button
                        type="button"
                        className="pi-promptbar__tool"
                        aria-label="Attach"
                    >
                        <Attach24Regular />
                    </button>
                    <button
                        type="button"
                        className="pi-promptbar__tool"
                        aria-label="Voice input"
                    >
                        <Mic24Regular />
                    </button>
                    <button
                        type="button"
                        className="pi-promptbar__tool"
                        aria-label="Save as prompt"
                        disabled={!canSave}
                        onClick={onSave}
                    >
                        <Bookmark24Regular />
                    </button>
                    <span className="pi-promptbar__spacer" />
                    <button
                        type="button"
                        className="pi-promptbar__send"
                        aria-label="Send"
                        disabled={!canSend}
                        onClick={onSend}
                    >
                        <Send24Filled />
                    </button>
                </div>
            </div>
            <div className="pi-promptbar__hint">
                PAR Intelligence can make mistakes. Verify important numbers.
            </div>
        </div>
    );
};

export default IntelligencePromptBar;
